import { W as WuiCheckInput$1, d as defineCustomElement$1 } from './p-CDhEAnE1.js';

const WuiCheckInput = WuiCheckInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiCheckInput, defineCustomElement };
